import React, { useEffect, useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import './loader.components.css'
import { Spinner } from 'react-bootstrap';

const Loader: React.FC = ({ }) => {
    return (
        <div className='auditor-loading-overlay auditor-component-overlay'>
            {/* <ProgressSpinner /> */}
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    );

};

export default Loader